/* eslint-disable sort-exports/sort-exports */
/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';

import fetchAllTripsReducerMap, {
    fetchAllTripsAction,
} from './actions/fetchAllTrips';
import fetchCachedTripsReducerMap, {
    fetchCachedTripsAction,
} from './actions/fetchCachedTrips';
import fetchSearchPlacesReducerMap, {
    fetchSearchPlacesAction,
} from './actions/fetchSearchPlaces';
import {
    fetchCarrierData,
} from './actions/tripSummary/fetchCarrierData';
import fetchTripReducerMap, {
    fetchTripsAction,
} from './actions/tripSummary/fetchTrip';
import {
    liveCheckItinerary,
    refreshLiveCheckItinerary,
} from './actions/tripSummary/liveCheckItinerary';
import {
    removeTripsWithId,
} from './actions/tripSummary/removeTripsWithId';
import {
    ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
    CARRIER_IS_ACTIVE_DEFAULT,
    CHEAPEST,
    DEFAULT_SORT,
    DIRECT_ONLY_IS_ACTIVE_DEFAULT,
    EARLIEST,
    FASTEST,
    FEATURE_IS_ACTIVE_DEFAULT,
    LATEST,
    MULTIMODAL_TYPE,
    RECOMMENDED,
    SORT_TYPES_ARRAY,
    STATION_IS_ACTIVE_DEFAULT,
    TIMING_DEFAULT,
    TRAVEL_MODES_IS_ACTIVE_DEFAULT,
} from './appstate/filterData/constants';
import filterReducerMap, {
    actions as filterActions,
    selectors as filterSelectors,
} from './appstate/filters';
import searchReducerMap, {
    actions as searchActions,
    selectors as searchSelectors,
} from './appstate/search';
import tripSummaryReducerMap, {
    actions as tripSummaryActions,
    selectors as tripSummarySelectors,
} from './appstate/tripSummary';
import {
    selectors as tripSelectors,
} from './appstate/trips';
import namespace from './types';
import { serializeFilterParams } from './utils';

const reducer = combineReducers({
    ...fetchCachedTripsReducerMap,
    ...fetchAllTripsReducerMap,
    ...fetchSearchPlacesReducerMap,
    ...fetchTripReducerMap,

    ...filterReducerMap,
    ...searchReducerMap,
    ...tripSummaryReducerMap,
});

export {
    fetchAllTripsAction,

    fetchCachedTripsAction,
    fetchCarrierData,
    fetchSearchPlacesAction,

    fetchTripsAction,
    filterActions,
    ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
    filterSelectors,
    CARRIER_IS_ACTIVE_DEFAULT,

    liveCheckItinerary,
    DIRECT_ONLY_IS_ACTIVE_DEFAULT,
    serializeFilterParams,
    FEATURE_IS_ACTIVE_DEFAULT,
    MULTIMODAL_TYPE,
    refreshLiveCheckItinerary,
    DEFAULT_SORT,

    removeTripsWithId,
    FASTEST,
    searchActions,
    CHEAPEST,
    searchSelectors,
    EARLIEST,
    tripSelectors,
    LATEST,
    tripSummaryActions,
    RECOMMENDED,
    tripSummarySelectors,
    SORT_TYPES_ARRAY,
    STATION_IS_ACTIVE_DEFAULT,
    TIMING_DEFAULT,
    TRAVEL_MODES_IS_ACTIVE_DEFAULT,
};

export default {
    [namespace]: reducer,
};
